<template>
  <div class="dataKanban">
    <Row>
      <Col span="12">
        <div class="right_box">
          <div class="right_content">
            <div class="right_title">
              <span class="block"></span>
              <span>空白市场排行</span>
            </div>
            <div class="right_title_left">
              <RadioGroup
                v-model="whiteRadio"
                @on-change="whiteRadioChange"
                type="button"
                size="small"
              >
                <Radio label="按大区排名"></Radio>
                <Radio label="按省排名"></Radio>
                <Radio label="按市排名"></Radio>
              </RadioGroup>
            </div>
          </div>
          <div class="echarts_box">
            <div id="drawLineWhite" :style="{width: '400px', height: '350px'}"></div>
            <Table height="150" style="margin-top:20px" :columns="columns" :data="data"></Table>
          </div>
        </div>
      </Col>
      <Col span="12">
        <div class="left_box">
          <div class="left_box_top">
            <div class="left_content">
              <div class="left_title">
                <span class="block"></span>
                <span>店铺新开趋势</span>
              </div>
              <div>
                <RadioGroup
                  v-model="newOpenButton"
                  @on-change="newOpenButtonChange"
                  type="button"
                  size="small"
                >
                  <Radio label="近3个月"></Radio>
                  <Radio label="近6个月"></Radio>
                  <Radio label="近一年"></Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="echarts_box">
              <div id="drawLineNewOpen" :style="{width: '400px', height: '250px'}"></div>
            </div>
          </div>
          <div class="left_box_bottom">
            <div class="left_content">
              <div class="left_title">
                <span class="block"></span>
                <span>店铺关闭原因分析</span>
              </div>
              <div class="left_title_left">
                <RadioGroup
                  v-model="closeReasonRadio"
                  @on-change="closeReasonChnage"
                  type="button"
                  size="small"
                >
                  <Radio label="近3个月"></Radio>
                  <Radio label="近6个月"></Radio>
                  <Radio label="自定义时间"></Radio>
                </RadioGroup>
                <DatePicker
                  v-if="showDate"
                  type="daterange"
                  @on-change="onChange"
                  @on-open-change="onOpenChange"
                  placement="bottom-end"
                  placeholder="请选择日期"
                  :value="changeDateValue"
                  style="width: 200px;margin-top:6px;"
                ></DatePicker>
              </div>
              <!-- v-model="changeDateValue" -->
            </div>
            <div class="echarts_box echarts_box_bottom">
              <div id="drawLineCloseReason" :style="{width: '50%', height: '200px'}"></div>
              <div class="line_box"></div>
              <div class="legend_box">
                <span
                  class="legend_content"
                  v-for="(item,index) in this.closeReasonOptions.series[0].data"
                  :key="index"
                >
                  <div class="legend_right">
                    <span class="legend" :style=" { border : ' 2px' + item.color + ' solid ' } "></span>
                    <span>{{item.name}}</span>
                  </div>
                  <span>{{(item.value / allCounts * 100).toFixed(2)}}%</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      whiteRadio: "按大区排名",
      newOpenButton: "近3个月",
      closeReasonRadio: "近3个月",
      whiteCondition: 1,
      newOpenCondition: 1,
      closeReasonCondition: 1,
      showDate: false,
      columns: [],
      data: [],
      allCounts: 0,
      changeDateValue: [],

      whiteOptions: {
        tooltip: {
          trigger: "item",
          confine: false,
          formatter: "{a}:{c}/{d}%"
        },
        legend: {
          data: ["空白市场"],
          bottom: 0,
          itemHeight: 2,
          itemWidth: 14
        },
        grid: { left: '2%', right: '2%', bottom: '10%', containLabel: true },
        xAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#BFBFBF"
            }
          },
          nameTextStyle: {
            color: "#000000",
            fontSize: 20
          }
          // show: false
        },
        yAxis: {
          type: "category",
          data: [],
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: "#BFBFBF",
            }
          },
          // nameTextStyle: {
          //   color: "#E21918",
          //   fontSize: 20,
          // },
        },
        series: [
          {
            name: "空白市场",
            type: "bar",
            barWidth: 18,
            itemStyle: {
              color: "#1890FF"
            },
            data: []
          }
        ]
      },
      newOpenOptions: {
        xAxis: {
          type: "category",
          axisTick: {
            alignWithLabel: true
          },
          data: [],
          axisLine: {
            lineStyle: {
              color: "#BFBFBF"
            }
          },
          nameTextStyle: {
            color: "#000000",
            fontSize: 20
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: ["店铺新开个数"],
          bottom: 13,
          itemHeight: 2,
          itemWidth: 14
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#BFBFBF"
            }
          },
          nameTextStyle: {
            color: "#000000",
            fontSize: 20
          },
          axisTick: {
            alignWithLabel: true
          },
          data: []
        },
        series: [
          {
            name: "店铺新开个数",
            data: [],
            type: "line",
            itemStyle: {
              color: "#1890FF"
            },
            smooth: true
          }
        ]
      },
      closeReasonOptions: {
        tooltip: {
          trigger: "item",
          confine: false,
          formatter: "{b}:占比{d}%"
        },
        color: ["#E87070", "#68A4D9", "#FF832C", "#8EC452", "#8EC452"],
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              }
            },
            // labelLine: {
            //   normal: {
            //     show: false
            //   }
            // },
            data: []
          }
        ]
      }
    };
  },
  mounted() {
    // document.getElementById("content").style.background = "#dcdcdc";
    // document.getElementById("content").style.padding = "0px";
    document.getElementsByClassName("ark-row")[0].style.height = "100%";
    document.getElementsByClassName("ark-row")[0].style.margin = "0px";
    document.getElementsByClassName("ark-col")[0].style.height = "100%";
    document.getElementsByClassName("ark-col")[0].style.paddingRight = "8px";
    document.getElementsByClassName("ark-col")[1].style.height = "100%";
    document.getElementsByClassName("ark-col")[1].style.paddingLeft =
      "8px";

    this.getDataWhite();

    this.getDataNewOpen();

    this.getDataCloseReason();
  },

  methods: {
    whiteRadioChange() {
      if (this.whiteRadio == "按大区排名") {
        this.whiteCondition = 1;
      } else if (this.whiteRadio == "按省排名") {
        this.whiteCondition = 2;
      } else if (this.whiteRadio == "按市排名") {
        this.whiteCondition = 3;
      }
      this.getDataWhite();
    },
    newOpenButtonChange() {
      if (this.newOpenButton == "近3个月") {
        this.newOpenCondition = 1;
      } else if (this.newOpenButton == "近6个月") {
        this.newOpenCondition = 2;
      } else if (this.newOpenButton == "近一年") {
        this.newOpenCondition = 3;
      }
      this.getDataNewOpen();
    },
    closeReasonChnage() {
      if (this.closeReasonRadio == "近3个月") {
        this.showDate = false;
        this.closeReasonCondition = 1;
        this.getDataCloseReason();
      } else if (this.closeReasonRadio == "近6个月") {
        this.showDate = false;
        this.closeReasonCondition = 2;
        this.getDataCloseReason();
      } else if (this.closeReasonRadio == "自定义时间") {
        this.showDate = true;
        this.closeReasonCondition = 3;
      }
    },
    onOpenChange(value) {
      if (!value) {
        this.getDataCloseReason(
          this.changeDateValue[0],
          this.changeDateValue[1]
        );
      }
    },
    onChange(value) {
      this.changeDateValue = value;
    },
    getDataNewOpen() {
      axios({
        url: "/p/cs/scrm/v1/shopOpenTrend",
        method: "get",
        params: {
          condition: this.newOpenCondition
        }
      }).then(res => {
        if (res.data.code === 0) {
          let cc = [];
          res.data.data.XData.map((element, index) => {
            cc[index] = `${element.split("-")[1]}${element.split("-")[2] ? '-' + element.split("-")[2] : ''}`;
          });
          console.log(cc);
          this.newOpenOptions.xAxis.data = cc;
          this.newOpenOptions.series[0].data = res.data.data.YData;
          this.drawLineNewOpen();
        } else {
          this.$Modal.fcError({
            title: "提示",
            content: content
          });
        }
      });
    },
    getDataWhite() {
      axios({
        url: "/p/cs/scrm/v1/getBlankMarkets",
        method: "get",
        params: {
          condition: this.whiteCondition,
          size: 10
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.columns = res.data.data.columns;
          this.data = res.data.data.data1;
          this.columns.unshift({
            type: "index",
            width: 60,
            align: "center",
            renderHeader: (h, params) => h("span", "排名")
          });
          let cc = [];
          let dd = [];
          res.data.data.data1.map((item, index) => {
            cc[index] = item.area;
            dd[index] = item.counts;
          });
          this.whiteOptions.yAxis.data = cc.reverse();
          this.whiteOptions.series[0].data = dd.reverse();
          let whiteAll = dd.reduce((a, b) => a + b);
          // this.whiteOptions.tooltip.formatter = `{a}:{c}/${whiteAll}`;
          this.whiteOptions.tooltip.formatter = function (params) {
            return `${params.seriesName}: ${params.value} / 所占比: ${(params.value / whiteAll * 100).toFixed(2)}%`
          };

          this.drawLineWhite();
        } else {
          this.$Modal.fcError({
            title: "提示",
            content: content
          });
        }
      });
    },
    getDataCloseReason(startTime, endTime) {
      axios({
        url: "/p/cs/scrm/v1/shopClosedReason",
        method: "get",
        params: {
          startTime: startTime,
          endTime: endTime,
          condition: this.closeReasonCondition
        }
      }).then(res => {
        if (res.data.code === 0) {
          let cc = [];
          res.data.data.map((item, index) => {
            cc[index] = {
              value: item.counts,
              name: item.close_reason,
              color: this.closeReasonOptions.color[index]
            };
          });
          if (res.data.data && res.data.data.length == 0) {
            this.closeReasonOptions.series[0].data = [];
          } else {
            this.allCounts = cc.map(o => o.value).reduce((a, b) => a + b);
            this.closeReasonOptions.series[0].data = cc;
          }

          this.drawLineCloseReason();
        } else {
          this.$Modal.fcError({
            title: "提示",
            content: content
          });
        }
      });
    },
    // #1890FF
    drawLineWhite() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(
        document.getElementById("drawLineWhite")
      );
      // 绘制图表
      myChart.setOption(this.whiteOptions);
    },
    drawLineNewOpen() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(
        document.getElementById("drawLineNewOpen")
      );
      // 绘制图表
      myChart.setOption(this.newOpenOptions);
    },
    drawLineCloseReason() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(
        document.getElementById("drawLineCloseReason")
      );
      // 绘制图表
      myChart.setOption(this.closeReasonOptions);
    }
  }
};
</script>
<style lang="less">
.dataKanban {
  height: 100%;
  padding: 0px;
  background: #dcdcdc;
  .echarts_box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .legend_box {
      width: 30%;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .legend_content {
        display: block;
        display: flex;
        width: 100%;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .legend_right {
          display: flex;
          align-items: center;
        }
        .legend {
          display: block;
          width: 12px;
          height: 12px;
          background-color: white;

          border-radius: 50%;
          margin-right: 6px;
        }
      }
    }
    .line_box {
      width: 1px;
      height: 140px;
      padding: 24px 0px;
      border-right: 1px solid #d8d8d8;
    }
  }
  .echarts_box_bottom {
    flex-direction: row;
  }
  .right_box {
    padding: 10px 15px;
    height: 100%;
    background-color: white;
    .right_content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .right_title {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-weight: 700;
        letter-spacing: 0.8px;
        font-size: 13px;
        .block {
          display: block;
          width: 4px;
          height: 15px;
          background-color: black;
          margin-right: 6px;
        }
      }
    }
  }
  .left_box {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .left_box_top,
    .left_box_bottom {
      padding: 10px 15px;
      height: 49%;
      background-color: white;
      .left_content {
        display: flex;
        align-items: center;
        align-items: flex-start;
        justify-content: space-between;
        .left_title {
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 700;
          letter-spacing: 0.8px;
          font-size: 13px;
          .block {
            display: block;
            width: 4px;
            height: 15px;
            background-color: black;
            margin-right: 6px;
          }
        }
        .left_title_left {
          display: flex;
          flex-direction: column;
        }
      }
    }
    .left_box_bottom {
      .left_content {
        height: 56px;
      }
    }
  }
}
</style>
